document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-gallery-thumb]').forEach(button=>button.addEventListener('click',()=>{
    const main=document.getElementById('ProductMainImage');
    if(!main)return;
    main.src=button.dataset.src;
    document.querySelectorAll('[data-gallery-thumb]').forEach(item=>item.classList.remove('is-active'));
    button.classList.add('is-active');
  }));

  const panel=document.querySelector('[data-filter-panel]');
  const backdrop=document.querySelector('.filter-backdrop');
  const closeFilters=()=>{panel?.classList.remove('is-open');backdrop?.classList.remove('is-open');document.body.style.overflow=''};
  document.querySelector('[data-filter-open]')?.addEventListener('click',()=>{panel?.classList.add('is-open');backdrop?.classList.add('is-open');document.body.style.overflow='hidden'});
  document.querySelectorAll('[data-filter-close]').forEach(el=>el.addEventListener('click',closeFilters));

  if(window.matchMedia('(min-width: 761px)').matches){
    document.querySelectorAll('[data-filter-form] input[type="checkbox"], [data-filter-form] select').forEach(el=>el.addEventListener('change',()=>el.form.submit()));
  }

  class ProductRecommendations extends HTMLElement{
    connectedCallback(){
      fetch(this.dataset.url).then(r=>r.text()).then(text=>{
        const html=new DOMParser().parseFromString(text,'text/html').querySelector('product-recommendations');
        if(html&&html.innerHTML.trim())this.innerHTML=html.innerHTML;
      }).catch(()=>{});
    }
  }
  if(!customElements.get('product-recommendations'))customElements.define('product-recommendations',ProductRecommendations);
});
